const ITEMS = [
  "100% Plant-Forward",
  "Delhi NCR",
  "Bengaluru",
  "Science-Led Eating",
  "No Fads. No Fear.",
  "Rooted in Indian Kitchens",
  "Fermentation is Culture",
  "Keep Your Prana Flowing",
];

export const Marquee = ({ dark = false }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden py-5 border-y ${dark ? "bg-beet-deep border-white/10" : "bg-leaf-light/60 border-[#E7E2D7]"}`}
    >
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className={`font-serif italic text-lg md:text-xl px-6 flex items-center gap-12 ${dark ? "text-white/50" : "text-ink-soft/70"}`}
              >
                {item}
                <span className={`inline-block w-1.5 h-1.5 rounded-full ${dark ? "bg-turmeric/60" : "bg-clay/60"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
